module.exports = __webpack_public_path__ + "af9ebc6d92b763b7fa9d146e85c61031.jpg";